const initialState: any = {
    pending: false,
    success: false,
    error: false,
    data: null,
    params: null
}
  
export default initialState